import { lazy, type ComponentType } from "react";

type AiComponentsModule = typeof import("@brivity/ai-components");

type AiComponentName = {
  [K in keyof AiComponentsModule]: AiComponentsModule[K] extends ComponentType<never> ? K : never;
}[keyof AiComponentsModule];

type PropsOf<T> = T extends ComponentType<infer P> ? P : never;

export const loadAiComponents = (): Promise<AiComponentsModule> => import("@brivity/ai-components");

export const lazyAiComponent = <K extends AiComponentName>(name: K) =>
  lazy(() =>
    loadAiComponents().then((mod) => ({
      default: mod[name] as unknown as ComponentType<PropsOf<AiComponentsModule[K]>>,
    })),
  );

export default lazyAiComponent;
